/* Component Dependencies */
var contactUsSignInOptionTemplate = require('templates/contactUsSignInOption.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'contactUsSignInOption',
  template: {
    'contactUsSignInOption': contactUsSignInOptionTemplate
  },

  events: {
    'click .js-continue-as-guest': 'makeAjaxToRedirect',
  },

  bindEvents: function() {
    var _self = this;
    
    var signInOverlay = new Popup({
      url: $('.tile-contact-us-sign-in-option').data('url'),
      selector: '.tile-contact-us-sign-in-option .mi-popover',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    signInOverlay.register();
  },

  makeAjaxToRedirect: function _makeAjaxToRedirect (event) {
    event.preventDefault();
    var _self = this;
    var data = {
      "sessionToken": this.getSessionToken()
    };
    var ele = $(event.target);
    this.makeAjaxCall({
      url: ele.data('endpoint'),
      method: 'POST',
      data: JSON.stringify(data),
      success: _.bind(_self.ajaXCallbackForSignin, _self),
      error: _.bind(_self.ajaXCallbackForSignin, _self)
    });
  },

  ajaXCallbackForSignin: function _ajaXCallbackForSignin (data) {
    var status = data.status;

    if (status === 200) {
      window.location.reload();
    }
  }
  
});